$('.menu-navigation, .menu-sidebar')
    .find('.current-menu-ancestor, .current-menu-parent, .current-menu-item')
    .children('.menu__item-link')
    .addClass('menu__item-link_current');


// WEBPACK FOOTER //
// ./scripts/components/menu.js